import { formattedPriceStringFromPence } from '@daymade/common-lib/formatting';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import styles from './OrderSummaryCosts.module.css';

const OrderSummaryCosts = observer(() => {
  const { orderCost, discountBannerText } = useEnterStore();

  const isDiscounted = orderCost.price !== orderCost.cost;
  return (
    <dl className={styles.container}>
      <dt>Weekly Subscription</dt>
      <dd>{formattedPriceStringFromPence(orderCost.price)} / week</dd>
      {isDiscounted && (
        <dt>
          This week{' '}
          {discountBannerText && (
            <span
              className={styles.discountBanner + ' aboutUsTypographyCaption'}
            >
              {discountBannerText}
            </span>
          )}
        </dt>
      )}
      {isDiscounted && (
        <dd>
          <span className={styles.oldPrice}>
            {formattedPriceStringFromPence(orderCost.price)}
          </span>{' '}
          <span>{formattedPriceStringFromPence(orderCost.cost)}</span>
        </dd>
      )}
    </dl>
  );
});

export default OrderSummaryCosts;
